/** Symbole WaitechEdu (W et toque), sur fond blanc : en-têtes et pieds du site public, console. */
export default function BrandMark({ className = "w-10 h-10" }: { className?: string }) {
  return (
    <img
      src="/logo-mark.png"
      alt="WaitechEdu"
      width={40}
      height={40}
      className={`${className} shrink-0 rounded-md bg-white object-contain`}
    />
  );
}
